<div [formGroup]="form">
  
  <div class="app-filter-bar" ngClass={{customClass}} [class.filter-collapsed]="isCollapsed === false">
    <ng-content select="[slotStart]"> </ng-content>

    <div class="search-input search-resp" *ngIf="shouldBeVisibleBuildInInputFilter">
      <i class="icon ftmi-search"></i>
      <input
        formControlName="filter"
        type="text"
        class="form-control"
        placeholder="Search"
        aria-describedby="searchBy"
        [attr.aria-label]="'SEARCH' | translate"
      />
    </div>
    <button
      *ngIf="shouldBeVisibleToggleExtraFilterButton"
      type="button"
      class="round-btn toggle-filter badge-counter-container"
      [ngClass]="{ 'filter-on': isCollapsed === false }"
      (click)="onCollapse()"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseFilter"
      [attr.aria-label]="'FILTER' | translate"
    >
      <i class="ftmi-filter" [appTooltip]="'FILTER' | translate">
        
      </i>
      <span class="badge-counter primary-badge" *ngIf="changedFieldsCount > 0">{{changedFieldsCount}}</span>
    </button>

    <ng-content select="[slotEnd]"> </ng-content>
  </div>

  
  <div id="collapseFilter" *ngIf="shouldBeVisibleEmbeddedFilters" [collapse]="isCollapsed" class="app-filter-collapse p-0">
      <div class="transparent-overlay" (click)="onCloseClick()" *ngIf="isCollapsed === false"></div>
      
      <div class="d-flex align-items-center justify-content-between filter-header">
        <h4 class="m-0 flex-grow-1 text-center">{{'APPLY_FILTERS' | translate}}</h4>
        <button type="button" class="btn" (click)="onCloseClick()">
          ✕
        </button>
      </div>

    <div class="container-fluid">
      <div class="row">
        <ng-container *ngIf="shouldBeVisibleRangeFilter">
          <div class="form-group mb-2 col-md-6 col-lg-12">
            <div class="app-input-sm datepicker-unit">
              <label for="name">{{ 'START_DATE' | translate }}</label>
              <input
                type="text"
                class="form-control"
                placeholder="{{ appConfig.Formats.DateShortFormat | uppercase }}"
                [maxDate]="form.controls.endDate.value && form.controls.endDate.value !== form.controls.startDate.value ? form.controls.endDate.value : null"
                bsDatepicker
                formControlName="startDate"
                [bsConfig]="bsConfig"
              />
            </div>
            <app-form-error [control]="form.controls.startDate"></app-form-error>
          </div>
          <div class="form-group mb-2 col-md-6 col-lg-12">
            <div class="app-input-sm datepicker-unit">
              <label for="name">{{ 'END_DATE' | translate }}</label>
              <input
                type="text"
                class="form-control"
                [minDate]="form.controls.startDate.value"
                placeholder="{{ appConfig.Formats.DateShortFormat | uppercase }}"
                bsDatepicker
                formControlName="endDate"
                [bsConfig]="bsConfig"
              />
            </div>
            <app-form-error [control]="form.controls.endDate"></app-form-error>
          </div>
        </ng-container>

        <ng-content> </ng-content>

        <div class="form-group mb-2 col-md-6 col-lg-12" *ngIf="shouldBeVisibleStatus">
          <app-status-select [className]="'app-input-sm'" [form]="form" [value]="filter?.status"> </app-status-select>
        </div>
      </div>
    </div>
    <div class="button-container">
      <div class="col text-center filter-buttons">
        <button type="button" class="btn btn-padded btn-radius btn-outline-primary mx-2" (click)="onClearFilters()" 
          [disabled]="!shouldEnableClearButton">
          {{ 'CLEAR' | translate }}
        </button>
        <button type="button" class="btn btn-primary btn-md-padded btn-radius" (click)="applyFilters()" [disabled]="!userHasMadeChanges">
          {{'APPLY' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
